/**
 * Filters and returns a list of unique counties by region from the provided intersecting counties.
 *
 * This function ensures that the resulting list contains counties with unique region codes
 * and excludes the county specified by `countyName` and `regionCode`.
 *
 */
import { GetFishingWater_fishingWater_intersectingCounties_edges_node } from '../../../interfaces/graphql';

export const getUniqueCountiesByRegion = (
  countyName: string,
  regionCode: string,
  intersectingCounties: GetFishingWater_fishingWater_intersectingCounties_edges_node[],
) => {
  return intersectingCounties.reduce<
    GetFishingWater_fishingWater_intersectingCounties_edges_node[]
  >((acc, county) => {
    if (
      !acc.some(item => item.region.regionCode === county.region.regionCode) &&
      (county.name !== countyName || county.region.regionCode !== regionCode)
    ) {
      acc.push(county);
    }
    return acc;
  }, []);
};
